

export function domacnostiButton_mouseIn(event) {
	$w("#boxMenuDomacnosti").show();
}


export function domacnostiButton_mouseOut(event) {
	$w("#boxMenuDomacnosti").hide();
}

export function boxMenuDomacnosti_mouseIn(event) {
	$w("#boxMenuDomacnosti").show();
}

export function boxMenuDomacnosti_mouseOut(event) {
	$w("#boxMenuDomacnosti").hide();
}


export function firmyButton_mouseIn(event) {
	$w("#boxMenuFirmy").show();
}


export function firmyButton_mouseOut(event) {
	$w("#boxMenuFirmy").hide();
}


export function infoButton_mouseIn(event) {
	$w("#boxMenuInfo").show();
}

export function infoButton_mouseOut(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuInfo_mouseIn(event) {
	$w("#boxMenuInfo").show();
}

export function boxMenuInfo_mouseOut(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuDomacnosti_mouseIn_1(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

export function boxMenuDomacnosti_mouseIn_2(event) {
	$w("#boxMenuDomacnosti").show();
}

export function boxMenuDomacnosti_mouseOut_1(event) {
	$w("#boxMenuDomacnosti").hide();
}

export function boxMenuFirmy_mouseIn(event) {
	$w("#boxMenuFirmy").show();
}

export function boxMenuFirmy_mouseOut(event) {
	$w("#boxMenuFirmy").hide();
}



/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function podporaText_click(event) {
	$w("#bigboxSupport").show(); 
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function podporaText_click_1(event) {
	$w("#bigboxSupport").show();
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 off of the element.

 > **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/tips-tutorials-examples/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function bigboxSupport_mouseOut_1(event) {
	$w("#bigboxSupport").hide();
}